import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Accesibilidad = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto max-w-3xl px-4 py-32">
        <h1 className="font-display text-3xl font-bold sm:text-4xl">Declaración de Accesibilidad</h1>

        <section className="mt-8 space-y-4 text-muted-foreground">
          <p>
            <strong className="text-foreground">Null Guard</strong> se compromete a garantizar la accesibilidad
            digital de su sitio web para todas las personas, incluidas aquellas con discapacidad.
          </p>

          <h2 className="text-xl font-semibold text-foreground">1. Estándar aplicado</h2>
          <p>
            Este sitio web ha sido diseñado siguiendo las{" "}
            <a
              href="https://www.w3.org/TR/WCAG21/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              Pautas de Accesibilidad para el Contenido Web (WCAG) 2.1
            </a>{" "}
            en su nivel de conformidad <strong className="text-foreground">AA</strong>, alineado con la norma
            europea{" "}
            <a
              href="https://www.etsi.org/deliver/etsi_en/301500_301599/301549/03.02.01_60/en_301549v030201p.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              EN 301 549
            </a>
            .
          </p>

          <h2 className="text-xl font-semibold text-foreground">2. Estado de conformidad</h2>
          <p>
            Este sitio web es <strong className="text-foreground">parcialmente conforme</strong> con WCAG 2.1 nivel AA.
            «Parcialmente conforme» significa que algunas partes del contenido no se ajustan completamente a todos
            los criterios de conformidad.
          </p>

          <h2 className="text-xl font-semibold text-foreground">3. Contenido no accesible</h2>
          <p>El contenido que se indica a continuación no es accesible por los siguientes motivos:</p>
          <ul className="list-inside list-disc space-y-1">
            <li>
              Algunos elementos interactivos de terceros (scripts de HubSpot y reCAPTCHA) pueden no cumplir
              plenamente con todos los criterios de accesibilidad, al estar fuera de nuestro control directo.
            </li>
            <li>
              Determinadas animaciones al scroll podrían no respetar completamente la preferencia{" "}
              <code className="rounded bg-muted px-1 py-0.5 text-sm text-foreground">prefers-reduced-motion</code>{" "}
              en todos los navegadores.
            </li>
          </ul>

          <h2 className="text-xl font-semibold text-foreground">4. Medidas adoptadas</h2>
          <p>Null Guard aplica las siguientes medidas para asegurar la accesibilidad del sitio:</p>
          <ul className="list-inside list-disc space-y-1">
            <li>Enlace «Ir al contenido principal» (skip-to-content) visible para navegación por teclado.</li>
            <li>Indicadores de foco visibles en todos los elementos interactivos.</li>
            <li>Estructura semántica con uso correcto de encabezados, landmarks y atributos ARIA.</li>
            <li>Contraste de color conforme a WCAG 2.1 AA (ratio mínimo 4.5:1 para texto normal).</li>
            <li>Textos alternativos en todas las imágenes informativas.</li>
            <li>Diseño responsive adaptado a distintos tamaños de pantalla y niveles de zoom hasta 200 %.</li>
          </ul>

          <h2 className="text-xl font-semibold text-foreground">5. Compatibilidad</h2>
          <p>
            Este sitio web está diseñado para ser compatible con las siguientes tecnologías de asistencia:
          </p>
          <ul className="list-inside list-disc space-y-1">
            <li>Lectores de pantalla (NVDA, JAWS, VoiceOver)</li>
            <li>Navegación exclusiva por teclado</li>
            <li>Ampliadores de pantalla</li>
          </ul>

          <h2 className="text-xl font-semibold text-foreground">6. Contacto</h2>
          <p>
            Si encuentra alguna barrera de accesibilidad o tiene sugerencias para mejorar, puede contactarnos en{" "}
            <a href="mailto:info@nullguard.xyz" className="text-primary hover:underline">
              info@nullguard.xyz
            </a>
            . Nos comprometemos a responder en un plazo máximo de 15 días hábiles.
          </p>

          <h2 className="text-xl font-semibold text-foreground">7. Procedimiento de aplicación</h2>
          <p>
            Si tras contactar con nosotros no obtiene una respuesta satisfactoria, puede presentar una
            reclamación ante el{" "}
            <a
              href="https://www.oadis.mdsocialesa2030.gob.es/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              Ministerio de Derechos Sociales, Consumo y Agenda 2030
            </a>
            .
          </p>

          <h2 className="text-xl font-semibold text-foreground">8. Fecha</h2>
          <p>
            Esta declaración fue elaborada el <strong className="text-foreground">17 de febrero de 2026</strong> y
            se revisará periódicamente.
          </p>
        </section>

        <nav aria-label="Otras páginas legales" className="mt-12 flex flex-wrap gap-4 border-t border-border pt-8 text-sm">
          <a href="/aviso-legal" className="text-primary hover:underline">Aviso legal</a>
          <a href="/politica-de-privacidad" className="text-primary hover:underline">Política de privacidad</a>
        </nav>
      </main>
      <Footer />
    </div>
  );
};

export default Accesibilidad;
